module.exports = __webpack_public_path__ + "static/Full Control 3-d4fa36d36ec53dc1d8bd9a58148f4623.png";